.text-area {
  height: 100%;
  width: 100%;

  background-color: white;
  padding: 0.25rem 0.5rem;
  font-size: 1rem;
  line-height: 1.6;
  min-height: 2.2em;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;

  .ql-snow {
    .ql-picker.ql-font,
    .ql-picker.ql-size {
      height: fit-content;
      width: fit-content;

      .ql-picker-label {
        width: fit-content;
        padding-right: 2em;
      }
    }

    .ql-picker-options .ql-picker-item {
      padding: 0;
    }

  }

  .quill {
    border-bottom-left-radius: .5em;
    border-bottom-right-radius: .5em;
    background-color: white;
    overflow: visible;
    height: calc(100% - 3em) !important;

    .ql-toolbar.ql-snow {
      border: none;
      border-bottom: solid 1px fade(black, 50%);
      display: block;
      position: sticky !important;
      z-index: 1;
      top: 0;
      background-color: white;

      & > .ql-picker.ql-font {
        width: 300px;
      }
    }

    .ql-container.ql-snow {
      border: none;
      font-size: 1em;

      .ql-picker-options {
        transform: translate3d(0, 0, 10px);
        z-index: 10;
        background-color: yellow;
      }
    }

    .ql-editor.ql-snow {
      top: 3em;
      z-index: 0; // TODO: ineffective without a position
      min-height: 9em;
      background-color: white;
    }
  }
}

.content-block--size-small {
  .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
	border-color: #ccc;
	max-height: 20em;
	overflow: auto;
  }
}


